module.exports = __webpack_public_path__ + "img/choujiang3.e6c5bdcf.png";